import { render, staticRenderFns } from "./FreeBanner.vue?vue&type=template&id=5202cc08&scoped=true"
import script from "./FreeBanner.vue?vue&type=script&lang=js"
export * from "./FreeBanner.vue?vue&type=script&lang=js"
import style0 from "./FreeBanner.vue?vue&type=style&index=0&id=5202cc08&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5202cc08",
  null
  
)

export default component.exports